import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'trgovina',
  storage: window.localStorage,
  reducer: state => ({
    // keepThisModule: state.keepThisModule,
    cart: state.cart,
    store: state.store,
    layout: state.layout,
    system: state.system,
  })
})

const shop = {
  namespaced: true,
  state: {
    cart: false,
    checkout: false,
    products: {
      1: {
        code: '1111',
        name: 'Sit amet Lorem',
        description: 'Dolore sit amet Lorem ipsum',
        quantity: '2',
        price: '10.00',
        currency: 'USD'
      },
      2: {
        code: '2222',
        name: 'Dolore sit',
        description: 'Lorem ipsum Dolore sit amet',
        quantity: '3',
        price: '10.00',
        currency: 'USD'
      },
      3: {
        code: '3333',
        name: 'Some product',
        description: 'Dolore sit amet Lorem ipsum',
        quantity: '3',
        price: '15.00',
        currency: 'USD'
      },
      4: {
        code: '4444',
        name: 'Some product',
        description: 'Lorem ipsum Dolore sit amet',
        quantity: '1',
        price: '10.00',
        currency: 'USD'
      },
      5: {
        code: '5555',
        name: 'Some product',
        description: 'Dolore sit amet Lorem ipsum',
        quantity: '3',
        price: '15.00',
        currency: 'USD'
      },
      6: {
        code: '6666',
        name: 'Some product',
        description: 'Lorem ipsum Dolore sit amet',
        quantity: '1',
        price: '10.00',
        currency: 'USD'
      }
    }
  },
  mutations: {
    toggleCart (state) {
      state.cart = !state.cart
    },
    toggleCheckout (state) {
      state.checkout = !state.checkout
    },
    removeProduct (state, product) {
      state.products[product].quantity--
    },
    addProduct (state, product) {
      state.products[product].quantity++
    },
    resetProduct (state, payload) {
      state.products[payload.product].quantity += payload.qty
    },
  },
  actions: {
    displayCart({ commit }) {
      commit('toggleCart');
    },
    hideCart({ commit }) {
      commit('toggleCart');
    },
    displayCheckout({ commit }) {
      commit('toggleCheckout');
    },
    hideCheckout({ commit }) {
      commit('toggleCheckout');
    },
    addedProduct({ commit }, product) {
      commit('removeProduct', product);
    },
    removedProduct({ commit }, product ) {
      commit('addProduct', product)
    },
    resetProduct({ commit }, payload ) {
      commit('resetProduct', {
        product: payload.product, 
        qty: payload.qty
      })
    },
  },
  getters : {
    shop: state => {
      return state
    }
  }
}

const cart = {
  namespaced: true,
  state: {
    items: 0,
    products: {}
  },
  mutations: {
    addProduct (state, product) {
      if( Object.keys(state.products).length ) { 
        if( state.products[product]) {
          state.products[product]++
        } else {
          state.products[product] = 1
        }
      } else {
        state.products[product] = 1
      }
    },
    removeProduct (state, product) {
      if( Object.keys(state.products).length ) { 
        if( state.products[product]) {
          state.products[product]--
        } else {
          delete state.products[product]
        }
      } else {
        delete state.products[product]
      }
    },
    increase (state) {
      state.items++
    },
    decrease (state) {
      state.items--
    },
    reset (state) {
      if( Object.keys(state.products).length ) {
        for (let product in state.products) {
          state.items = (state.items - state.products[product])
          let qty = state.products[product]
          this.dispatch('shop/resetProduct', {
            product: product, 
            qty: qty
          })
        }
        state.items = 0
        state.products = {}
      }
    },
  },
  actions: {
    addCart({ commit }, product) {
      commit('increase');
      commit('addProduct', product);
    },
    delCart({ commit }, product) {
      commit('decrease');
      commit('removeProduct', product);
    },
    resetCart({ commit }) {
      commit('reset');
    }
  },
  getters : {
    cart: state => {
      return state
    }
  }
}

const layout = {
  namespaced: true,
  state: { 
    drawer: {
      model: false,
      mini: false,
      theme: false,
    }
  },
  mutations: { 
    miniSwitch (state) {
      state.drawer.mini = !state.drawer.mini;
    },
    themeSwitch (state, val) {
      state.drawer.theme = !val
      // state.drawer.theme = !state.drawer.theme;
    }
  },
  actions: { 
    toggleMini({ commit }) {
      commit('miniSwitch');
    },
    toggleTheme({ commit }, theme) {
      commit('themeSwitch', theme);
    }
  },
  getters: { 
    drawer: state => {
      return state.drawer
    }
  },
}

const system = {
  namespaced: true,
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user : {}
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token, user){
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
    },
  },
  actions: {
    login({ commit }, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        if(user.email === process.env.VUE_APP_EMAIL && user.password === process.env.VUE_APP_PWD) {
          localStorage.setItem("token", "JWT")
          commit('auth_success', "JWT", user)
          resolve()
        } else {
          commit('auth_error')
          localStorage.removeItem('token')
          reject()
        }
      });
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        resolve()
      })
    },
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    status: state => {
      return state.status
    }
  }
}

export default new Vuex.Store({
  modules: {
    shop: shop,
    cart: cart,
    layout: layout,
    system: system,
  },
  plugins: [vuexLocalStorage.plugin],
})
